import type { GetAssetResponse } from '@borradh-workspace/contracts';
import { useQueries } from '@tanstack/react-query';
import { getAssetQueryOptions } from '../get-asset/get-asset.hook';
import type { Asset } from '../types';

/** Stock assets and older uploads can sit outside the first raw-footage page. */
export function useSelectedAssetMetadata(
  ids: readonly string[],
  known: readonly Asset[]
) {
  const knownIds = new Set(known.map((asset) => asset.id));
  const missing = [...new Set(ids)].filter((id) => !knownIds.has(id));
  const queries = useQueries({ queries: missing.map(getAssetQueryOptions) });
  const byId = new Map<string, Asset | GetAssetResponse>(
    known.map((asset) => [asset.id, asset])
  );
  for (const result of queries)
    if (result.data) byId.set(result.data.id, result.data);
  return [...byId.values()];
}
